import { render, staticRenderFns } from "./AccountAssetFormType.vue?vue&type=template&id=60344eeb&scoped=true&"
import script from "./AccountAssetFormType.vue?vue&type=script&lang=ts&"
export * from "./AccountAssetFormType.vue?vue&type=script&lang=ts&"
import style0 from "./AccountAssetFormType.vue?vue&type=style&index=0&id=60344eeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60344eeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
